import { call, put, select, takeLatest } from 'redux-saga/effects'

import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { showSnackbar, SNACKBAR_TYPES } from '@/shared/tools/notifications/notification'
import { callApi } from '@/shared/tools/apiSagaHelperV2'

import {
  submitRequest,
  submitSuccess,
  submitFailure,
} from './nettingUpdaterSlice'

import { selectNettingUpdaterOrganizationId } from './nettingUpdaterSelectors'

export const nettingUpdaterActions = {
  SUBMIT: 'ORGANIZATIONS/NETTING_UPDATER/SUBMIT',
}

function* submitNettingUploadSaga({ enqueue, t, file }) {
  yield put(submitRequest())

  try {
    const { extraRoutes } = yield select(selectAuthData)
    const url = extraRoutes?.nettingProcess?.upload
    if (!url) {
      const message = t?.('netting.errors.missing_url') || 'Missing netting upload url'
      yield put(submitFailure({ error: message }))
      if (enqueue) yield call(showSnackbar, enqueue, { type: SNACKBAR_TYPES.ERROR, message })
      return
    }

    const organizationId = yield select(selectNettingUpdaterOrganizationId)
    if (!organizationId || !file) {
      const message = t?.('netting.errors.invalid_form') || 'Veuillez sélectionner un fichier'
      yield put(submitFailure({ error: message }))
      if (enqueue) yield call(showSnackbar, enqueue, { type: SNACKBAR_TYPES.WARNING, message })
      return
    }

    const formData = new FormData()
    formData.append('organization_id', String(organizationId))
    formData.append('file', file)

    const data = yield callApi({
      endpoint: url,
      method: 'POST',
      payload: formData,
      enqueue,
      showErrorSnackbar: true,
    })

    const message = data?.message || ''

    yield put(submitSuccess({ message }))

    if (enqueue) {
      yield call(showSnackbar, enqueue, {
        type: SNACKBAR_TYPES.SUCCESS,
        message: message || (t?.('netting.success') || 'Upload lancé avec succès'),
      })
    }
  } catch (error) {
    const message = error?.message || 'Unknown error'
    yield put(submitFailure({ error: message }))
    if (enqueue) {
      yield call(showSnackbar, enqueue, { type: SNACKBAR_TYPES.ERROR, message })
    }
  }
}

export default function* nettingUpdaterSagas() {
  yield takeLatest(nettingUpdaterActions.SUBMIT, submitNettingUploadSaga)
}
